// web-v2/src/lib/declineReasons.js
//
// FRONTEND MIRROR of the declination vocabulary. The source of truth is
// data/decline-reasons.json, resolved server-side by utils/decline-canon.js.
// This file exists because the browser bundle cannot require() a node util, and
// it is the same arrangement web-v2/src/lib/quoteFields.js has for coverage
// types.
//
// tests/decline-canon-frontend.test.js PINS this list against
// data/decline-reasons.json, so editing one side without the other fails the
// deploy gate. Do not add a value here by hand: add it to the JSON and let the
// gate tell you to mirror it.
//
// REASONS ARE PLURAL. A carrier gives as many as it wants and the second is
// routinely the one that matters: IAT declined N541HF for insufficient hours
// AND a student certificate, and only the certificate explains why every other
// market passed too. The dialog is checkboxes, not radios, for that reason.

export const DECLINE_REASONS = [
  { value: 'appetite_aircraft', label: 'Aircraft out of appetite (type/age)' },
  { value: 'appetite_use', label: 'Use / operations out of appetite' },
  { value: 'pilot_experience', label: 'Pilot hours / time in type' },
  { value: 'pilot_certificate', label: 'Pilot certificate / ratings held' },
  { value: 'loss_history', label: 'Loss / claims history' },
  { value: 'hull_value', label: 'Hull value / exposure' },
  { value: 'territory', label: 'Territory / geography' },
  { value: 'rate', label: 'Could not compete on rate' },
  { value: 'capacity', label: 'No capacity / limits unavailable' },
  { value: 'incomplete', label: 'Incomplete submission' },
  { value: 'not_stated', label: 'Declined without giving a reason' },
  { value: 'other', label: 'Other (detail required)' },
];

// 'other' is the ONLY value that requires an explanation. not_stated must not:
// it means the carrier said nothing, and demanding a sentence describing a
// silence is a form that nags. Mirrors DETAIL_REQUIRED in utils/decline-canon.js.
export const DETAIL_REQUIRED = ['other'];

export function requiresDetail(reasons) {
  return (reasons || []).some((r) => DETAIL_REQUIRED.includes(r));
}

const LABELS = Object.fromEntries(DECLINE_REASONS.map((r) => [r.value, r.label]));

// Render stored reasons for a human. Reads the plural array and ONLY the array:
// scripts/decline-reasons-plural.sql migrated every row, and the deploy gate
// asserts against live data that no scalar survives, so accepting a bare
// `reason` here would be reading two shapes to locate one fact.
//
// An unrecognised value still prints as itself with underscores stripped, so a
// vocabulary addition that reaches the data before this mirror is updated
// degrades to readable text rather than vanishing.
export function declineLabels(declination) {
  const list = Array.isArray(declination?.reasons) ? declination.reasons : [];
  return list.map((r) => LABELS[r] || String(r).replace(/_/g, ' '));
}
